import { googleLogout } from '@react-oauth/google';
import { Storage } from '../utils/storage';
import {
  appLocationState,
  getCurrentSession,
  getLastSession,
} from './restoreLocation';

export type AccessToken = {
  accessToken: string;
  _id: string;
  isTemporary?: boolean;
};

const memorySession: { [s: string]: string } = {};

// TODO: move these state to session zustand
export const getItem = (key: string): string | undefined => {
  const cacheValue = memorySession[key];

  if (cacheValue) return cacheValue;

  const storedValue = Storage.localStore.getItem(key) || undefined;

  if (storedValue) memorySession[key] = storedValue;

  return storedValue;
};

export const getToken = (): string | undefined => {
  const guestToken = sessionStorage.getItem('accessToken');
  if (guestToken) return guestToken;

  const temporarySessionToken =
    appLocationState.getState().temporarySessionToken;
  if (temporarySessionToken) return temporarySessionToken;

  const session = getCurrentSession();
  if (session) return session.accessToken;
  const lastSession = getLastSession();
  return lastSession?.accessToken;
};

export const isAuthenticated = (): boolean => getToken() !== undefined;

export const setItem = (key: string, value: string | null): void => {
  if (value) {
    Storage.localStore.setItem(key, value);
    memorySession[key] = value;
  } else {
    Storage.localStore.removeItem(key);
    delete memorySession[key];
  }
};

export const logout = (): void => {
  const { removeAllSessions } = appLocationState.getState();
  removeAllSessions();
  localStorage?.removeItem('ui-state-storage');
  googleLogout();
};

export const getEncodedSession = () => {
  const currentSession = getCurrentSession();

  // const stringifiedSessions = getItem(STORAGE_KEY);

  if (!currentSession) return undefined;

  return window.btoa(currentSession.toString());
};

export * as Session from './session';
